import React from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {safeHTML} from "../../utils/safeHTML";
import styles from "./Quiz.module.scss"
import classNames from "classnames";


const QuizStart = React.forwardRef(
  function QuizStart(props, ref) {
    const {description, preview, onClick} = props;

    return (
      <div className={styles.quiz__start} ref={ref}>
        <div className={styles.quiz__preview}>
          <img src={preview} alt="Превью" loading={"eager"} fetchpriority={"high"} width={1312} height={600}/>
        </div>
        <p className={styles.quiz__description}>{safeHTML(description)}</p>
        <Button className={classNames(
          buttonStyles.button_black,
          buttonStyles.button_big,
          styles.quiz__button)}
                onClick={onClick}
        >
          <span className={buttonStyles.button__text}>{`Начать тест`}</span>
        </Button>
      </div>
    );
  });
export default QuizStart;
QuizStart.propTypes = {};

